<li>
    <form class="search-xmpp-contact">
        <input type="text"
            name="identifier"
            class="username"
            placeholder="{{{o.label_contact_name}}}"/>
        <button type="submit">{{{o.label_search}}}</button>
    </form>
</li>
